import styled, { css } from "styled-components";
import { parseCSS } from "scripts/FunctionsBundle";
import NewText from "@components/NewText";

// ################################ INTERFACES & PROPS ################################

type _Base = import("utils/class-types").Base;
// AboutScreen => Rename all instances to use
type AboutScreenProps = {} & _Base;

// ################################ RENDERING COMPONENT ################################

const _AboutScreen = (props: AboutScreenProps) => {
  return (
    <div className={props.className + " screen"}>
      <NewText _text={"This is the About Screen"} _type={"subtitle"} />
    </div>
  );
};

// ################################ STYLES ################################
const AboutScreen = styled(_AboutScreen).attrs((props): AboutScreenProps => {
  return { ...props };
})`
  ${(props) => css`
    ${parseCSS(props._style)}
  `}
`;

// ################################ EXPORTS ################################

export default AboutScreen;
